// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"871":"a48c30db","939":"6baf705f","975":"0831cf24"}[chunkId] + ".css";
};